// Un scénario de jeu par action du bandit manchot (data/cast.js) ; la course d'origine sert de
// secours pour une action qui n'en aurait pas. Interface : voir common.js.
import { race } from './race.js';
import { love } from './love.js';
import { fight } from './fight.js';
import { kiss } from './kiss.js';
import { hug } from './hug.js';
import { scare } from './scare.js';
import { tickle } from './tickle.js';
import { dance } from './dance.js';

export const SCENARIOS = Object.freeze({ love, fight, kiss, hug, scare, tickle, dance });

export function scenarioFor(actionId) {
  return SCENARIOS[actionId] ?? race;
}
